export const PROJECT_CONSTANTS ={
    CODE_VERIFIER_CHARSET: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890.,-_~"
} 